module.exports = __webpack_public_path__ + "img/empty-news.png?8b8a4db5";